import moment$1 from 'moment';

function numberFormat(number) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var min = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  return number.toLocaleString('da', {
    minimumFractionDigits: min,
    maximumFractionDigits: max
  });
}
function moneyFormat(number) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var min = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  var curr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'DKK';
  var value = numberFormat(number, max, min);
  return typeof curr === "string" ? "".concat(value, " ").concat(curr) : "".concat(value);
}
function enumerateWithRest(elements) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var extras = Math.min(elements.length - max, 0);
  return elements.slice(0, max).join(", ") + (extras > 0 ? " +".concat(extras) : "");
}
function roundToFives(n) {
  var division = n / 5;
  var whole = Math.floor(division);
  var rest = Math.round(division - whole);
  return (whole + rest) * 5;
}
function firstToUpper(string) {
  if (typeof string !== 'string') return string;
  return string.replace(/^[a-zA-Z0-9_æøåÆØÅ]/, function (c) {
    return c.toUpperCase();
  });
}
function allToUpper(string) {
  if (typeof string !== 'string') return string;
  return string.replace(/\b(\w)/g, function (c) {
    return c.toUpperCase();
  });
}
function dateFormat(DT) {
  var outputFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "DD.MM.YYYY";

  if (DT) {
    var formats = ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD", "YYYYMMDDHHmmss"];
    var orgDate = DT.date ? DT.date : DT;

    for (var index = 0; index < formats.length; index++) {
      var format = formats[index];
      var date = moment$1(orgDate, format).format(outputFormat);

      if (date != 'Invalid date') {
        return date;
      }
    }
  }
}
function statusDecode(status) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (status) {
    case "published":
      return {
        type: "green",
        label: label ? label : "Udgivet"
      };

    case "draft":
      return {
        type: "yellow",
        label: "Kladde"
      };

    case "deleted":
      return {
        type: "red",
        label: label ? label : "Slettet"
      };

    case "aktiv":
      return {
        type: "green",
        label: label ? label : "Aktiv"
      };

    case "inaktiv":
      return {
        type: "red",
        label: label ? label : "Inaktiv"
      };

    case "active":
      return {
        type: "green",
        label: label ? label : "Aktiv"
      };

    case "inactive":
      return {
        type: "red",
        label: label ? label : "Inaktiv"
      };

    case "expired":
      return {
        type: "red",
        label: "Udløbet"
      };

    default:
      return {
        type: "grey",
        label: label ? label : "Ukendt"
      };
  }
}
function dayToString(number) {
  switch (number) {
    case 0:
      return "Mandag";

    case 1:
      return "Tirsdag";

    case 2:
      return "Onsdag";

    case 3:
      return "Torsdag";

    case 4:
      return "Fredag";

    case 5:
      return "Lørdag";

    case 6:
      return "Søndag";

    default:
      return "Error";
  }
}
function urlSlug(string) {
  if (typeof string !== 'string') return string;
  var val = string.toLowerCase().replace(/[ ]/g, '-').replace(/[.]/g, '');
  return encodeURIComponent(val);
}

export { allToUpper, dateFormat, dayToString, enumerateWithRest, firstToUpper, moneyFormat, numberFormat, roundToFives, statusDecode, urlSlug };
//# sourceMappingURL=format.js.map
